import { Phone } from 'lucide-react';

const WHATSAPP_NUMBER = '50379557231';
const MESSAGE = encodeURIComponent('Hola, vi GymPro SV y quiero más información sobre la prueba gratis.');

export function WhatsAppWidget() {
    return (
        <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${MESSAGE}`}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 left-6 z-50 flex items-center gap-2 h-14 px-5 rounded-full bg-green-500 text-white shadow-xl shadow-green-500/30 hover:bg-green-600 hover:scale-105 transition-all duration-300 animate-in fade-in slide-in-from-bottom-4 duration-700"
            aria-label="Contactar por WhatsApp"
        >
            <div className="relative">
                <Phone className="h-6 w-6 fill-white" />
                <span className="absolute -top-1 -right-1 h-3 w-3 bg-green-300 rounded-full animate-ping" />
            </div>
            <span className="text-sm font-bold hidden sm:inline">¿Dudas? Escríbenos</span>
        </a>
    );
}
